export default __webpack_public_path__ + "static/media/030-wasabi.179588c3.svg";